import storeRoot from '../store-root'
import mock from '../../services/mock'
import http from '../../services/http'

const moduleName = 'Demo'

storeRoot.registerModule(moduleName, {
  namespaced: true,
  actions: {
    async getDemoList () {
      let result = await http.get('/api/demo', mock({name: '张三'}))
      return result.data
    }
  }

})

export default moduleName
